<template>
  <div class="app-promo-footer" v-if="!dismissed">
    <div class="app-promo-footer__container">
      <!-- Logo a la izquierda -->
      <img
        src="/favicon/apple-icon-57x57.png"
        alt="HelloBB logo"
        class="app-promo-footer__logo"
      />

      <!-- Texto + CTA a la derecha -->
      <div class="app-promo-footer__content">
        <div class="app-promo-footer__title">{{ $t("apppromo.title") }}</div>
        <div class="app-promo-footer__bottom">
          <div class="app-promo-footer__text">
            {{ $t("apppromo.subtitle") }}
          </div>
          <a
            @click="downloadApp()"
            target="_blank"
            rel="noopener"
            class="app-promo-footer__button"
          >
            {{ $t("apppromo.ctaDownloadAppStore") }}
          </a>
        </div>
      </div>
    </div>
    <button class="app-promo-footer__close" @click="dismissed = true" aria-label="Cerrar">
      ×
    </button>
  </div>
</template>

<script>
export default {
  name: "AppPromoFooter",
  data() {
    return {
      dismissed: false,
    };
  },
  methods: {
    downloadApp() {
      window.open("/mobile-app-download?utm_source=guest-list", "_blank");
    },
  },
};
</script>

<style scoped>
.app-promo-footer {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #1e0028;
  color: white;
  z-index: 900;
  padding: 12px 16px;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
}

.app-promo-footer__container {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
}

.app-promo-footer__logo {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  background: white;
  border-radius: 12px;
  padding: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.app-promo-footer__content {
  flex: 1;
  min-width: 0; /* clave para evitar que el botón se corte */
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.app-promo-footer__title {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 4px;
}

.app-promo-footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap; /* permite que el botón baje si no cabe */
  gap: 8px;
}

.app-promo-footer__text {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #e0e0e0;
}

.app-promo-footer__button {
  background: #ffc944;
  color: #1e0028;
  border-radius: 50px;
  font-weight: bold;
  padding: 8px 14px;
  text-decoration: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.app-promo-footer__close {
  position: absolute;
  top: 6px;
  right: 8px;
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

@media (max-width: 768px) {
  .app-promo-footer {
    display: block;
  }
}

@media (max-width: 480px) {
  .app-promo-footer__container {
    flex-direction: row;
    align-items: center;
  }

  .app-promo-footer__bottom {
    flex-wrap: nowrap;
    flex-direction: row;
  }

  .app-promo-footer__button {
    width: auto;
    text-align: right;
  }

  .app-promo-footer__text {
    flex: 1;
  }
  .app-promo-footer__title {
    font-size: 14px;
  }
}
</style>
